<template>
  <transition name="fade">
    <div class="loading" >
      <span :style="{'border-color':color}"></span>
     <!-- <p>加载中</p> -->
     </div>
  </transition>
</template>

<script>
export default {
  name: 'loadingCircle',
  props: {
    color: String
  },
  data(){
    return{
    }
  }
}
</script>
<style scoped >
  .loading{
  position: fixed;
  border-radius: 0.08rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}
.loading span{
    background-color: #fff;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    margin: 2px;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    border: 2px solid #fff;
    border-bottom-color: transparent !important;;
    height: 25px;
    width: 25px;
    background: transparent !important;
    display: inline-block;
    -webkit-animation: rotate 0.75s 0s linear infinite;
    animation: rotate 0.75s 0s linear infinite;
  }
  
  
 .loading p{
    margin-top: 0.1rem;
    font-size: 0.12rem;
    color: #fff;
  }
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }

  50% {
    -webkit-transform: rotate(180deg) scale(1);
    transform: rotate(180deg) scale(1);
  }

  100% {
    -webkit-transform: rotate(360deg) scale(1);
    transform: rotate(360deg) scale(1);
  }
}

</style>